import React, { useContext } from 'react';
import { ThemeContext } from 'providers/ThemeProvider';
import { Container, Card, TitleWrap } from 'components/common';
import { Wrapper, Grid, Item, Content, Stats, Languages } from './styles';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import projects from './projects.json';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

export const Projects = () => {
  const { theme } = useContext(ThemeContext);

  return (
    <Wrapper as={Container} id="projects">
      <h2>Projects</h2>
      <List
        sx={{ width: '100%', maxWidth: '100%', bgcolor: 'background.paper' }}
        component="nav"
        aria-labelledby="nested-list-subheader"
      >
        {projects.map((project) => (
          <ListItemButton key={project.id}
            sx={{ width: '100%' }}
            component="a" href={project.link} target="_blank">
            <ListItemText primary={project.name}
              secondary={project.description} />
            <Stack direction="row" spacing={1}>
              {project.tags.map((tag) => {
                return <Chip label={tag} />
              })}
            </Stack>
          </ListItemButton>
        ))}
      </List>
    </Wrapper>
  );
};
